import { __read, __values } from "tslib";
import { arrayIncludes, asType } from '@dazn/peng-html5-tools-utils';
import { getPort } from './getPort';
import { parseDevelopmentPackages } from './parseDevelopmentPackages';
var createDevelopmentPortsConfig = function (coreHarnessPath, developmentPackageName) {
    var e_1, _a;
    var _b, _c;
    if (coreHarnessPath === void 0) { coreHarnessPath = (_b = "undefined") !== null && _b !== void 0 ? _b : ''; }
    if (developmentPackageName === void 0) { developmentPackageName = (_c = "undefined") !== null && _c !== void 0 ? _c : ''; }
    var corePort = getPort(coreHarnessPath);
    var devPackages = parseDevelopmentPackages(developmentPackageName);
    var assignedPorts = [];
    var portsConfig = {};
    var automaticallyAssignedPortsCount = 0;
    try {
        for (var devPackages_1 = __values(devPackages), devPackages_1_1 = devPackages_1.next(); !devPackages_1_1.done; devPackages_1_1 = devPackages_1.next()) {
            var devPackage = devPackages_1_1.value;
            var _d = __read(asType(devPackage.split(':')), 2), name_1 = _d[0], portAsString = _d[1];
            var port = void 0;
            if (portAsString) {
                // An explicit port has been provided via the CLI
                port = Number(portAsString);
            }
            else {
                // No port has been provided, automatically assign one
                var proposedPort = void 0;
                do {
                    proposedPort = corePort + automaticallyAssignedPortsCount + 1;
                    automaticallyAssignedPortsCount++;
                } while (arrayIncludes(assignedPorts, proposedPort));
                port = proposedPort;
                // eslint-disable-next-line no-console
                console.log("Development package \"".concat(name_1, "\" has been automatically assigned to ").concat(port, ". ") +
                    'Ensure that it is served from this port.');
            }
            portsConfig[name_1] = port;
            assignedPorts.push(port);
        }
    }
    catch (e_1_1) { e_1 = { error: e_1_1 }; }
    finally {
        try {
            if (devPackages_1_1 && !devPackages_1_1.done && (_a = devPackages_1.return)) _a.call(devPackages_1);
        }
        finally { if (e_1) throw e_1.error; }
    }
    return portsConfig;
};
export { createDevelopmentPortsConfig };
//# sourceMappingURL=createDevelopmentPortsConfig.js.map